// Partner (referral) program: labels and the program rules shown to agents.
// Money comes from the API in kopecks.
import { formatMoney } from './format';
import { tokens } from '../theme';

export const kopecks = (k) => formatMoney((Number(k) || 0) / 100, { kopecks: Number(k) % 100 !== 0 });

export const referralLink = (code) => `${window.location.origin}/r/${code}`;

export const COMMISSION_STATUS = {
  hold: { label: 'Ожидает', bg: tokens.warningSoft, fg: tokens.warning },
  available: { label: 'К выплате', bg: tokens.infoSoft, fg: tokens.info },
  paid: { label: 'Выплачено', bg: tokens.successSoft, fg: tokens.success },
  canceled: { label: 'Отменено', bg: tokens.errorSoft, fg: tokens.error },
};

export const CLIENT_STATUS = {
  active: { label: 'Активен', bg: tokens.primarySoft, fg: tokens.primaryDark },
  self: { label: 'Свой аккаунт', bg: tokens.errorSoft, fg: tokens.error },
  excluded: { label: 'Исключён', bg: tokens.errorSoft, fg: tokens.error },
  merged: { label: 'Дубль', bg: tokens.primaryTint, fg: tokens.inkSoft },
};

export const AGENT_STATUS = {
  pending: { label: 'На рассмотрении', bg: tokens.warningSoft, fg: tokens.warning },
  rejected: { label: 'Заявка отклонена', bg: tokens.errorSoft, fg: tokens.error },
  active: { label: 'Активен', bg: tokens.successSoft, fg: tokens.success },
  blocked: { label: 'Заблокирован', bg: tokens.errorSoft, fg: tokens.error },
  deleted: { label: 'Удалён', bg: tokens.primaryTint, fg: tokens.inkSoft },
};

// Why an agent is deleted (codes as on the server).
export const DELETE_REASONS = [
  { code: 'duplicate', label: 'Дубль аккаунта' },
  { code: 'account_deleted', label: 'Аккаунт пользователя удалён' },
  { code: 'test', label: 'Тестовая запись' },
  { code: 'agent_request', label: 'По просьбе агента' },
  { code: 'violation', label: 'Нарушение условий' },
  { code: 'other', label: 'Другое' },
];

export const EVENT_LABEL = {
  agent_joined: 'Стал агентом',
  agent_applied: 'Подана заявка',
  agent_approved: 'Заявка одобрена',
  agent_rejected: 'Заявка отклонена',
  agent_blocked: 'Заблокирован',
  agent_unblocked: 'Разблокирован',
  client_attached: 'Новый клиент',
  relinked_by_email: 'Клиент вернулся с той же почтой',
  relinked_by_seller: 'Клиент вернулся с тем же кабинетом',
  client_merged: 'Дубль клиента объединён',
  client_self: 'Клиент оказался самим агентом',
  client_active: 'Клиент возвращён в программу',
  client_excluded: 'Клиент исключён',
  commission_added: 'Начисление',
  commission_canceled: 'Начисление отменено',
  payout: 'Выплата',
  agent_deleted: 'Удалён',
  agent_restored: 'Восстановлен',
  deleted_agent_paid: 'Оплата клиента удалённого агента',
};

// The rules in plain words. percent / holdDays / graceDays come from the server.
export const programRules = ({ percent = 50, hold_days: holdDays = 14, grace_days: graceDays = 90 } = {}) => [
  `Вы получаете ${percent}% от первой оплаты каждого клиента, который зарегистрировался по вашей ссылке. Считается сумма, которую клиент реально заплатил, за любой срок: если он оплатил сразу год, ${percent}% от всей суммы.`,
  'Клиент закрепляется за тем агентом, по чьей ссылке он перешёл первым, навсегда. Повторная регистрация с той же почтой или с тем же кабинетом WB ничего не меняет.',
  'Переход засчитывается, если клиент зарегистрировался с того же телефона или компьютера и в том же браузере, где открыл ссылку. Кто пришёл на сайт сам, ни за кем не закрепляется.',
  `Начисление можно получить через ${holdDays} дней после оплаты клиента: это срок, в который клиент может вернуть деньги. Если деньги возвращены, начисление отменяется.`,
  'За свои собственные оплаты (свой аккаунт или свой кабинет WB) вознаграждение не начисляется.',
  'Выплату согласует администратор: он свяжется с вами по Telegram или телефону из кабинета. Минимальной суммы нет.',
  `Программу могут остановить. После остановки ещё ${graceDays} дней засчитываются переходы, сделанные до остановки, и оплаты клиентов.`,
  'Участие подтверждает администратор: ссылка начинает работать с момента, когда заявка одобрена. Переходы до одобрения не засчитываются.',
  'Запрещены спам, обман клиентов и реклама в соцсетях, где она запрещена законом РФ (Instagram, Facebook). Берите готовые ролики и тексты из нашего Telegram-канала. За нарушения участие прекращается без выплаты.',
];
